import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Footer() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <footer ref={ref} className="bg-[#000000] border-t border-[#333333] py-12 px-5">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <img 
            src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/34de0253fd17802be692fff692668476.png"
            alt="3DCARS.JP"
            className="w-16 h-16 object-contain mx-auto mb-4"
          />
          <h3 className="text-white text-3xl font-thin tracking-[0.4em] uppercase mb-3">
            3DCARS.JP
          </h3>
          <p className="text-[#888888] text-sm leading-relaxed">
            未来のホイール選びを、今ここで。
          </p>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 mb-8 text-center">
          {[
            { text: 'ホーム', href: '/', type: 'page' },
            { text: 'ホイール最新ニュース', href: '#news', type: 'anchor' },
            { text: '使い方ガイド', href: '/guide', type: 'page' },
            { text: 'お問い合わせ', href: '/contact', type: 'page' }
          ].map((link, index) => (
            <motion.a
              key={link.text}
              href={link.type === 'anchor' && window.location.pathname !== '/' ? '/' + link.href : link.href}
              onClick={(e) => {
                if (link.type === 'anchor' && window.location.pathname === '/') {
                  e.preventDefault();
                  const element = document.querySelector(link.href);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="text-[#cccccc] text-sm hover:text-[#00d4ff] transition-colors cursor-pointer"
            >
              {link.text}
            </motion.a>
          ))}
        </div>

        <div className="flex justify-center gap-4 mb-8">
          <motion.a
            href="https://www.instagram.com/3dcars_official/"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2 }}
            className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-[#f09433] via-[#e1306c] to-[#c13584] text-white hover:shadow-lg hover:shadow-[#e1306c]/50 transition-all cursor-pointer"
          >
            <i className="ri-instagram-fill text-xl"></i>
          </motion.a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.5 }}
          className="text-center mb-8"
        >
          <a 
            href="https://bridgeadvance.llc/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#cccccc] text-base hover:text-[#00d4ff] transition-colors cursor-pointer font-medium"
          >
            ブリッジアドバンス合同会社
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.6 }}
          className="text-center text-[#666666] text-xs"
        >
          <p>&copy; 2025 3D CARS. All rights reserved.</p>
        </motion.div>
      </div>
    </footer>
  );
}
